module.exports = __webpack_public_path__ + "img/germany-transport-accidents-female.d0faa5da.png";